import {FC} from 'react'
import {PopoverText} from '../../../../../components'
import {IFetchLogMasterDataResponse} from '../../../../../services/types'
import dateformat from 'src/utils/dateformat'

interface RowDataProps {
  showPreview: (p1: string, p2: any) => void
  items: IFetchLogMasterDataResponse['data']['data']
  rowNumber: number
}

export const RowData: FC<RowDataProps> = (props) => {
  const {items, rowNumber} = props

  return (
    <>
      {items.map((item, index) => (
        <tr key={item.id}>
          <td>{index + 1 + rowNumber}</td>
          <td>{item?.username || '-'}</td>
          <td>
            <PopoverText
              content={item?.agent ? item?.agent : '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>{item?.ip_address}</td>
          <td>
            <PopoverText
                content={item?.path}
                index={index}
                trigger='click'
                className='desc-slicee'
              />
          </td>
          <td>{item?.method}</td>
          <td>
            <a className='cursor-pointer hover-underline' href='javascript:void(0)' onClick={ () => props.showPreview('Request', item?.body) }>
              {(item?.body ?? '-').substr(0, 20)}
            </a>
          </td>
          <td>{item?.error_code}</td>
          <td>
            <PopoverText
              content={item?.message ? item?.message : '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>
            <a className='cursor-pointer hover-underline' href='javascript:void(0)' onClick={ () => props.showPreview('Request', item?.response) }>
              {(item?.response ?? '-').substr(0, 20)}
            </a>
          </td>
          <td>{item?.status}</td>
          <td>{dateformat(item?.created_at as string, {showtime: true})}</td>
        </tr>
      ))}
    </>
  )
}
